import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ModalRenameFileProps {
  open: boolean;
  fileName: string;
  onClose: () => void;
  onConfirm: (newName: string) => void;
}

const ModalRenameFile: React.FC<ModalRenameFileProps> = ({ open, fileName, onClose, onConfirm }) => {
  const [newName, setNewName] = useState(fileName);
  const { t, i18n } = useTranslation();
    
  useEffect(() => {
    const storedLang = localStorage.getItem('language') || 'EN';
    i18n.changeLanguage(storedLang);
  }, []);

  useEffect(() => {
    setNewName(fileName);
  }, [fileName]);

  const handleConfirm = () => {
    if (newName.trim()) {
      onConfirm(newName.trim());
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('renameFile')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label={t('newFileName')}
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleConfirm} variant="contained" sx={{ backgroundColor: '#73AF73' }}>{t('rename')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalRenameFile;